{
  "asset_id": "74365bfb-88c3-41f3-bb21-a5bc9585be01",
  "content_type": "image/png",
  "created_at": "2026-06-26T13:35:47Z",
  "original_filename": "entertainment-tv.png",
  "project_id": "1ee18af1-1d84-490c-8b4d-f96ad9f331fc",
  "r2_key": "a/v1/1ee18af1-1d84-490c-8b4d-f96ad9f331fc/74365bfb-88c3-41f3-bb21-a5bc9585be01/entertainment-tv.png",
  "size": 251094,
  "url": "/__l5e/assets-v1/74365bfb-88c3-41f3-bb21-a5bc9585be01/entertainment-tv.png",
  "version": 1
}